class GiftMessageForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.form = this.querySelector("form");

    if (!this.form) return;

    this.submit = this.querySelector("button");
    this.submitText = this.submit.innerHTML;

    const rawMessage = window.cartData.attributes?.gift_message || '';
    if (rawMessage) {
      const lines = rawMessage.split('\n');
      let i = 0;
      if (lines[i]?.startsWith('To: ')) {
        this.form.gift_message_to.value = lines[i].slice(4);
        i++;
      }
      if (lines[i]?.startsWith('From: ')) {
        this.form.gift_message_from.value = lines[i].slice(6);
        i++;
      }
      this.form.gift_message.value = lines.slice(i).join('\n');
    }

    this.onSubmit = (e) => {
      e.preventDefault();

      const gift_message = [
        this.form.gift_message_to.value
          ? `To: ${this.form.gift_message_to.value}`
          : null,
        this.form.gift_message_from.value
          ? `From: ${this.form.gift_message_from.value}`
          : null,
        this.form.gift_message.value,
      ]
        .filter(Boolean)
        .join("\n");

      const attributes = {
        gift_message,
      };

      const onAfterAdd = () => {
        this.submit.innerHTML = this.submitText;
        document.dispatchEvent(new CustomEvent("markup-modal:close-all"));
      };

      this.submit.innerHTML = window.localeStrings.cart.message_saving;

      window.updateCart(
        { attributes },
        {
          onError: (response) => {
            this.submit.innerHTML = this.submitText;
            this.showError(
              response?.message || window.localeStrings.cart.message_save_error,
            );
          },
          onAfterAdd,
        },
      );
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }

  showError(message) {
    const error = document.createElement("div");
    error.classList.add("add-to-cart-error");
    error.innerHTML = message;

    this.form.append(error);

    setTimeout(() => {
      error.remove();
    }, 3000);
  }
}

if (!customElements.get("gift-message-form")) {
  customElements.define("gift-message-form", GiftMessageForm);
}
